import { connect } from "react-redux";

import { IApiKey } from "@common/models";
import ApiKeys, { IApiKeysActions, IApiKeysProps } from "./api-keys";
import { getApiKeys, editApiKey, createNewApiKey, deleteApiKey } from "../user.actions";

export default connect(
  ({ user }: any): IApiKeysProps => {
    const { apiKeys, userId } = user;
    return { apiKeys, buttonIsDisabled: apiKeys && apiKeys.length > 4, userId };
  },
  (dispatch): IApiKeysActions => ({
    refreshApiKeys: () => dispatch(getApiKeys()),
    changeApiKeyName: (apiKey: IApiKey, newName: string) =>
      dispatch(editApiKey(apiKey, newName)),
    createNewApiKey: (userId: string) => dispatch(createNewApiKey(userId)),
    deleteApiKey: (userId: string, apiKeyName: string) => dispatch(deleteApiKey(userId, apiKeyName))
  })
)(ApiKeys);
